<template>
  <div>
    <div class="se-main">
      <div class="se-main-left">
        <div class="se-ava se-flex-v-c se-p-t-50 se-m-b-30">
          <el-avatar
            :size="88"
            :src="user.avatar || require('../../assets/images/logo2.png')"
          ></el-avatar>
          <div class="se-m-t-15 se-m-b-5 ft-14-333">
            {{ user.persionName || "新学员" }}
          </div>
          <!-- <div class="se-m-b-5">
            {{ user.thrLevelRule && user.thrLevelRule.levelName }}
          </div> -->
          <img
            v-if="user.thrLevelRule"
            :src="user.thrLevelRule.iconUrl"
            style="width: 90px; height: 30px; object-fit: cover"
          />
        </div>
        <!-- 左侧菜单 -->
        <el-menu
          class="el-menu-vertical-demo"
          :default-active="defaultActive"
          active-text-color="#E42335"
          @select="menuSelect"
        >
          <!-- <el-menu-item index="1">
            <div class="se-flex aic jcc" @click="isActive(1)">
              <img
                :src="
                  menuIcons === 1
                    ? require('../../assets/icons/daiban2.png')
                    : require('../../assets/icons/daiban1.png')
                "
                style="width: 16px; height: 16px"
              />
              <span class="se-m-r-10 se-m-l-10">我的待办</span>
            </div>
          </el-menu-item> -->
          <el-menu-item index="2">
            <div class="se-flex aic jcc" @click="isActive(2)">
              <img
                :src="
                  menuIcons === 2
                    ? require('../../assets/icons/study2.png')
                    : require('../../assets/icons/study1.png')
                "
                style="width: 19px; height: 15px"
              />
              <span class="se-m-r-10 se-m-l-10">我的学习</span>
            </div>
          </el-menu-item>
          <el-menu-item index="3">
            <div class="se-flex aic jcc" @click="isActive(3)">
              <img
                :src="
                  menuIcons === 3
                    ? require('../../assets/icons/pen2.png')
                    : require('../../assets/icons/pen1.png')
                "
                style="width: 15px; height: 17px"
              />
              <span class="se-m-r-10 se-m-l-10">我的考试</span>
            </div>
          </el-menu-item>
          <el-menu-item index="4">
            <div class="se-flex aic jcc" @click="isActive(4)">
              <img
                :src="
                  menuIcons === 4
                    ? require('../../assets/icons/flower2.png')
                    : require('../../assets/icons/flower1.png')
                "
                style="width: 15px; height: 17px"
              />
              <span class="se-m-r-10 se-m-l-10">我的评价</span>
            </div>
          </el-menu-item>
          <!-- <el-menu-item index="5">
            <div class="se-flex aic jcc" @click="isActive(5)">
              <img
                :src="
                  menuIcons === 5
                    ? require('../../assets/icons/course2.png')
                    : require('../../assets/icons/course1.png')
                "
                style="width: 16px; height: 16px"
              />
              <span class="se-m-r-10 se-m-l-10">我的授课</span>
            </div>
          </el-menu-item> -->
          <el-menu-item index="6">
            <div class="se-flex aic jcc" @click="isActive(6)">
              <img
                :src="
                  menuIcons === 6
                    ? require('../../assets/icons/courseware2.png')
                    : require('../../assets/icons/courseware1.png')
                "
                style="width: 16px; height: 16px"
              />
              <span class="se-m-r-10 se-m-l-10">上传课件</span>
            </div>
          </el-menu-item>
          <!-- <el-menu-item index="7">
            <div class="se-flex aic jcc" @click="isActive(7)">
              <img
                :src="
                  menuIcons === 7
                    ? require('../../assets/icons/cookie2.png')
                    : require('../../assets/icons/cookie1.png')
                "
                style="width: 16px; height: 16px"
              />
              <span class="se-m-r-10 se-m-l-10">统计分析</span>
            </div>
          </el-menu-item> -->
          <el-menu-item index="8">
            <div class="se-flex aic jcc" @click="isActive(8)">
              <img
                :src="
                  menuIcons === 8
                    ? require('../../assets/icons/userinfo2.png')
                    : require('../../assets/icons/userinfo1.png')
                "
                style="width: 15px; height: 20px"
              />
              <span class="se-m-r-10 se-m-l-10">个人信息</span>
            </div>
          </el-menu-item>
          <el-menu-item index="9">
            <div class="se-flex aic jcc" @click="isActive(9)">
              <img
                :src="
                  menuIcons === 9
                    ? require('../../assets/icons/set2.png')
                    : require('../../assets/icons/set1.png')
                "
                style="width: 17px; height: 17px"
              />
              <span class="se-m-r-10 se-m-l-10">账户设置</span>
            </div>
          </el-menu-item>
          <el-menu-item index="10">
            <div class="se-flex aic jcc" @click="logout">
              <img
                :src="
                  menuIcons === 10
                    ? require('../../assets/icons/logout2.png')
                    : require('../../assets/icons/logout1.png')
                "
                style="width: 15px; height: 17px"
              />
              <span class="se-m-r-10 se-m-l-10">退出登录</span>
            </div>
          </el-menu-item>
        </el-menu>
      </div>
      <!-- 右侧主体内容区域 -->
      <div class="se-main-right">
        <img
          src="../../assets/images/user.png"
          style="width: 100%; height: 190px; margin-bottom: 40px"
        />
        <!-- 待办 -->
        <!-- <template v-if="defaultActive === '1'">
          <todo></todo>
        </template> -->
        <!-- 我的学习 -->
        <template v-if="defaultActive === '2'">
          <my-study></my-study>
        </template>
        <!-- 我的考试 -->
        <template v-if="defaultActive === '3'">
          <my-test></my-test>
        </template>
        <!-- 我的评价 -->
        <template v-if="defaultActive === '4'">
          <my-evaluate></my-evaluate>
        </template>
        <!-- 我的课程 -->
        <template v-if="defaultActive === '5'">
          <my-course></my-course>
        </template>
        <!-- 我的课件 -->
        <template v-if="defaultActive === '6'">
          <my-courseware></my-courseware>
        </template>
        <!-- 统计分析 -->
        <template v-if="defaultActive === '7'">
          <statistical></statistical>
        </template>
        <!-- 个人信息 -->
        <template v-if="defaultActive === '8'">
          <userinfo></userinfo>
        </template>
        <!-- 账户设置 -->
        <template v-if="defaultActive === '9'">
          <account-settings></account-settings>
        </template>
      </div>
    </div>
    <!-- 底部浏览记录 -->
    <div class="se-flex jcsb aic se-p-t-30 se-p-b-25">
      <div class="ft-24-333">浏览记录</div>
      <div
        class="se-more cp"
        style="background-color: #f6f7f9"
        @click="$router.push('/records')"
      >
        <div class="se-p-r-10">更多</div>
        <img
          src="../../assets/icons/jia.png"
          style="width: 10px; height: 10px"
        />
      </div>
    </div>
    <div class="se-bottom-list se-flex jcsb">
      <div
        class="se-item pos-r"
        v-for="(item, i) in browseList"
        :key="i"
        @click="goInfo(item)"
      >
        <course-item :item="item"></course-item>
        <img
          v-if="(item.isHighQuality && item.isExcellent) || item.isHighQuality"
          src="../../assets/icons/jingpin.png"
          class="se-img-tj"
          style="width: 63px; height: 28px"
        />
        <img
          v-if="item.isExcellent"
          src="../../assets/icons/youxiu.png"
          class="se-img-tj"
          style="width: 63px; height: 28px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import courseItem from "../components/courseItem.vue";
// import todo from "./components/todo.vue";
import myStudy from "./components/myStudy.vue";
import myTest from "./components/myTest.vue";
import myEvaluate from "./components/myEvaluate.vue";
import myCourse from "./components/myCourse.vue";
import myCourseware from "./components/myCourseware.vue";
import statistical from "./components/statistical.vue";
import userinfo from "./components/userinfo.vue";
import accountSettings from "./components/accountSettings.vue";

export default {
  components: {
    courseItem,
    // todo,
    myStudy,
    myTest,
    myEvaluate,
    myCourse,
    myCourseware,
    statistical,
    userinfo,
    accountSettings,
  },

  data() {
    return {
      user: this.$store.state.userInfo,
      defaultActive: "2",
      menuIcons: 0,
      browseList: [],
    };
  },

  watch: {
    "$store.state.userInfo": {
      handler(value) {
        this.user = value;
        this.$forceUpdate();
      },
      deep: true,
    },
    "$route.query.t"(value) {
      this.defaultActive = this.$route.query.defaultActive.toString();
      this.menuIcons = Number(this.$route.query.defaultActive);
      console.log(this.defaultActive, "this.defaultActive");
      console.log(this.menuIcons, "this.menuIcons");
    },
    "$route.query.code"(value) {
      this.getBind(value);
    },
  },

  created() {
    this.init();
    this.getBrowseList();
    if (this.$route.query.code) {
      this.getBind(this.$route.query.code);
    }
  },

  methods: {
    async getBind(code) {
      await this.$http.get(
        `server/portal/personCenter/bindingWeChat?code=${code}`
      );
      const user = await this.$http.get(
        "server/portal/personCenter/getUserDetails"
      );
      await this.$store.dispatch("setUserInfo", user.data);
      this.$router.redirect({
        name: this.$route.name,
        query: {
          t: new Date().getTime(),
          defaultActive: 9,
        },
      });
    },
    goInfo(item) {
      // this.$router.push({ name: "courseInfo", query: { type: "course" } });
      this.$router.push({
        name: "courseInfo",
        query: {
          type: "course",
          courseId: item.courseId,
          teacherId: item.teacherId,
          t: new Date().getTime(),
        },
      });
    },

    // 初始化
    init() {
      if (this.$route.query.defaultActive) {
        this.defaultActive = this.$route.query.defaultActive.toString();
        this.menuIcons = Number(this.$route.query.defaultActive);
        // console.log(this.defaultActive);
      }
    },

    logout() {
      this.$confirm("确认退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$store.dispatch("setToken", "");
          this.$nextTick(() => {
            this.$router.push("/login");
          });
          this.$message({
            type: "success",
            message: "退出成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    // 菜单选择回调
    menuSelect(e) {
      console.log(e, "e");
      this.defaultActive = String(e);
    },

    // 去浏览记录
    go() {
      this.$router.push({ name: "search" });
    },

    isActive(value) {
      // console.log(value, "value");
      if (this.menuIcons === value) return;
      this.menuIcons = value;
      this.$router.push({
        name: "user",
        query: {
          defaultActive: String(value),
          type: "1",
        },
      });
    },

    // 去课程详情
    goCourseInfo() {
      this.$router.push({ name: "courseInfo", query: { type: "course" } });
    },

    //获取浏览记录
    getBrowseList() {
      this.$http
        .get("/server/portal/personCenter/browseRecordList", {
          pageSize: 4,
          pageNum: 1,
        })
        .then((res) => {
          if (res.code == 200) {
            this.browseList = res.rows;
            if (this.browseList.length > 4) {
              this.browseList = this.browseList.slice(0, 4);
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.se-main {
  width: 100%;
  display: flex;
}

.se-main-left {
  width: 240px;
  background-color: #f8fafc;
  border-radius: 10px 0 0 10px;
}

.se-main-right {
  flex: 1;
  background-color: #fff;
  padding: 20px 30px;
  border-radius: 0 10px 10px 0;
}

/deep/ .el-menu-item.is-active {
  background-color: #fff;
}

/deep/ .el-menu-item {
  background-color: #f8fafc;
}

/deep/ .el-menu-item:hover {
  background-color: #f5f5f5;
}

/deep/ .el-menu {
  border: none;
}

.se-bottom-list {
  width: 100%;
  justify-content: flex-start;
  .se-item {
    width: calc((100% - 90px) / 4);
    background-color: #fff;
    border-radius: 10px;
    margin: 0 30px 30px 0;
    &:last-child {
      margin-right: 0;
    }
  }
}

.se-img-tj {
  position: absolute;
  right: -1px;
  top: -1px;
}

.se-more {
  width: 100px;
  height: 35px;
  background-color: #fff !important;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
